module.exports = __webpack_public_path__ + "static/media/viewIcon.2e0e9e50.svg";